class Instrument {
  /**
   *
   * @param {import("../..").IInstrument} param
   */
  constructor(param = {}) {
    Object.assign(this, param);
  }
  get changePercentageStr() {
    return this.changePercentage > 0 ? "+" + this.changePercentage : this.changePercentage;
  }
  get changeStr() {
    return this.change > 0 ? "+" + this.change : this.change;
  }
  get isMarketOpen() {
    return this.marketStatus === "Open";
  }
}

export default Instrument;
